module.exports = __webpack_public_path__ + "img/Viking-line1.66511c6c.jpg";